// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.register-modal {
  /* background: white; */
  background: linear-gradient(180deg, #0f172a, #020617);
  border-radius: 16px;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}
/* Scrollable Content */
.modal-content-scroll {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
  max-height: calc(90vh - 140px);
}

/* Custom Scrollbar */
.modal-content-scroll::-webkit-scrollbar {
  width: 8px;
}

.modal-content-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.modal-content-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.modal-content-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
}

.modal-header h2 {
  font-size: 20px;
  margin-bottom: 4px;
}

.modal-header p {
  font-size: 13px;
  color: #94a3b8;
}

.close-icon {
  cursor: pointer;
  opacity: 0.7;
}

.close-icon:hover {
  opacity: 1;
}

/* GRID */
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 10px;
}

.full {
  grid-column: span 2;
}

/* INPUT */
label {
  font-size: 13px;
  color: #cbd5f5;
}

input {
  width: 100%;
  margin-top: 6px;
  padding: 11px 12px;
  border-radius: 12px;
  border: 1px solid #1e293b;
}

input:focus {
  outline: none;
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
}

/* UPLOAD */
.upload-box {
  border: 2px dashed #334155;
  border-radius: 14px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  cursor: pointer;
}

/* SECTION */
.section-title {
  margin-top: 20px;
  font-size: 15px;
  font-weight: 600;
}

/* ACTIONS */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
}

.cancel-btn {
  background: transparent;
  border: 1px solid #334155;
  color: white;
  padding: 10px 18px;
  border-radius: 12px;
  cursor: pointer;
}

.submit-btn {
  background: #facc15;
  color: #020617;
  font-weight: 600;
  padding: 10px 22px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
}

/* Add these styles to your Addusers.css */

.user-select-section {
  margin-bottom: 20px;
  /* padding: 15px; */
   background: transparent;
  /* background-color: #f8f9fa; */
  border-radius: 8px;
}

.user-dropdown {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  margin-top: 5px;
}

.user-dropdown:focus {
  outline: none;
  border-color: #4a90e2;
}

.buyer-form {
  margin: 20px 0;
  padding: 15px;
  /* background-color: #f8f9fa; */
  border-radius: 8px;
}

.buyer-form div {
  width: 100%;
}

.buyer-form input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-top: 5px;
}

.buyer-form input:focus {
  outline: none;
  border-color: #4a90e2;
}

select:disabled,
input:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/Adduser/Addusers.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA,0CAA0C;;AAE1C;EACE,mBAAmB;EACnB,mBAAmB;GAClB,uBAAuB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.register-modal {\n  /* background: white; */\n  background: linear-gradient(180deg, #0f172a, #020617);\n  border-radius: 16px;\n  width: 90%;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n/* Scrollable Content */\n.modal-content-scroll {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n  max-height: calc(90vh - 140px);\n}\n\n/* Custom Scrollbar */\n.modal-content-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modal-content-scroll::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 10px;\n}\n\n.modal-content-scroll::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n}\n\n.modal-content-scroll::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n}\n\n.modal-header h2 {\n  font-size: 20px;\n  margin-bottom: 4px;\n}\n\n.modal-header p {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.close-icon {\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.close-icon:hover {\n  opacity: 1;\n}\n\n/* GRID */\n.grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-top: 10px;\n}\n\n.full {\n  grid-column: span 2;\n}\n\n/* INPUT */\nlabel {\n  font-size: 13px;\n  color: #cbd5f5;\n}\n\ninput {\n  width: 100%;\n  margin-top: 6px;\n  padding: 11px 12px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n}\n\ninput:focus {\n  outline: none;\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n}\n\n/* UPLOAD */\n.upload-box {\n  border: 2px dashed #334155;\n  border-radius: 14px;\n  height: 110px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  cursor: pointer;\n}\n\n/* SECTION */\n.section-title {\n  margin-top: 20px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n/* ACTIONS */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.cancel-btn {\n  background: transparent;\n  border: 1px solid #334155;\n  color: white;\n  padding: 10px 18px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  background: #facc15;\n  color: #020617;\n  font-weight: 600;\n  padding: 10px 22px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Add these styles to your Addusers.css */\n\n.user-select-section {\n  margin-bottom: 20px;\n  /* padding: 15px; */\n   background: transparent;\n  /* background-color: #f8f9fa; */\n  border-radius: 8px;\n}\n\n.user-dropdown {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.user-dropdown:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.buyer-form {\n  margin: 20px 0;\n  padding: 15px;\n  /* background-color: #f8f9fa; */\n  border-radius: 8px;\n}\n\n.buyer-form div {\n  width: 100%;\n}\n\n.buyer-form input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  margin-top: 5px;\n}\n\n.buyer-form input:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\nselect:disabled,\ninput:disabled {\n  background-color: #e9ecef;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
